import React from 'react';
import { Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { usePageStats } from '../context/PageTitleContext';
import { useSidebar } from '../context/SidebarContext';

/**
 * Statistics Cards Component
 * Displays a row of statistic cards with icons
 * @param {array} stats - Array of stat objects: { label, value, icon, color }
 */
const StatsCards = ({ stats }) => {
  const { isMobile } = useSidebar();
  // Su desktop i contatori vanno in navbar accanto al titolo (piu' spazio per la tabella);
  // su mobile la navbar non li mostra, quindi restano le card nel corpo pagina.
  usePageStats(isMobile ? [] : (stats || []).map(({ label, value, color }) => ({ label, value, color })));

  if (!isMobile || !stats || stats.length === 0) return null;

  const textColors = {
    primary: 'text-primary',
    success: 'text-success',
    info: 'text-info',
    warning: 'text-warning',
    danger: 'text-danger',
    secondary: 'text-secondary',
  };

  // Mobile: contatori compatti affiancati (etichetta piccola sopra, valore sotto)
  return (
    <div className="d-flex gap-2 mb-3" style={{ overflowX: 'auto' }}>
      {stats.map((stat, index) => (
        <Card key={index} className="flex-fill" style={{ minWidth: 0 }}>
          <Card.Body className="p-2 text-center">
            <small className="text-muted d-block text-truncate" style={{ fontSize: '0.7rem' }}>
              {stat.icon && <FontAwesomeIcon icon={stat.icon} className={`me-1 ${textColors[stat.color] || ''}`} />}
              {stat.label}
            </small>
            <div className={`fw-bold ${stat.valueColor ? `text-${stat.valueColor}` : ''}`} style={{ fontSize: '1.05rem', lineHeight: 1.2 }}>
              {stat.value}
            </div>
          </Card.Body>
        </Card>
      ))}
    </div>
  );
};

export default StatsCards;
